import { BpCard } from '../../../../shared/components/cards/card/BpCard'
import { Square } from '../../../../shared/components/utility/square/Square'
import { Controller, useForm } from 'react-hook-form'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { usePostProfileChangePasswordMutation } from '../../../../app/api'
import { FormControls } from '../../../../shared/components/forms/form-controls/FormControls'
import { useTranslation } from 'react-i18next'
import { validatePassword } from '../../../../shared/lib/helpers/ValidatePassword'
import clsx from 'clsx'
import styles from './ChangePasswordlForm.module.scss'

export interface IChangePasswordFormData {
  password: string
  new_password: string
}

export const ChangePasswordForm = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const [editPassword] = usePostProfileChangePasswordMutation()

  const {
    control,
    getValues,
    handleSubmit,
    formState: { isDirty, isValid },
    reset,
    register,
  } = useForm<IChangePasswordFormData>({
    defaultValues: { password: '', new_password: '' },
    mode: 'onChange',
  })

  return (
    <Square className={className}>
      <form
        onSubmit={handleSubmit((data: IChangePasswordFormData) =>
          editPassword({ changePasswordForm: data }).then((response) => {
            if ('error' in response || !response.data.success) {
              return
            } else {
              reset()
            }
          }),
        )}
      >
        <BpCard
          footer={<FormControls disabled={!isDirty || !isValid} onCancel={() => reset()} />}
          title={t('pages.profile.changePassword')}
        >
          <div className={clsx(styles.formFields)}>
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('password', { required: t('fields.validate.required') })}
                  required
                  error={error?.message}
                  label={t('pages.profile.fields.currentPassword')}
                  placeholder={t('pages.profile.fields.enterPassword')}
                  type='password'
                />
              )}
              control={control}
              name='password'
            />
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('new_password', {
                    required: t('fields.validate.required'),
                    validate: (value) => validatePassword(value, t),
                  })}
                  required
                  autoComplete='off'
                  disabled={!getValues('password')}
                  error={error?.message}
                  label={t('pages.profile.fields.newPassword')}
                  placeholder={t('pages.profile.fields.enterNewPassword')}
                  type='password'
                />
              )}
              control={control}
              name='new_password'
            />
          </div>
        </BpCard>
      </form>
    </Square>
  )
}
